import {
    UtensilsCrossed,
    CheckCircle2,
    Star,
    Flame,
    ShoppingBag,
    IndianRupee,
} from "lucide-react";

import "./FoodStats.css";

function FoodStats({ stats }) {

    const cards = [
        {
            title: "Total Foods",
            value: stats.total,
            icon: <UtensilsCrossed size={24} />,
            color: "red",
        },
        {
            title: "Available",
            value: stats.available,
            icon: <CheckCircle2 size={24} />,
            color: "green",
        },
        {
            title: "Featured",
            value: stats.featured,
            icon: <Star size={24} />,
            color: "yellow",
        },
        {
            title: "Best Seller",
            value: stats.bestSeller,
            icon: <Flame size={24} />,
            color: "orange",
        },
        {
            title: "Today's Special",
            value: stats.specials,
            icon: <ShoppingBag size={24} />,
            color: "blue",
        },
        {
            title: "Revenue",
            value: `₹${(stats.revenue || 0).toLocaleString()}`,
            icon: <IndianRupee size={24} />,
            color: "purple",
        },
    ];

    return (

        <div className="food-stats-grid">

            {cards.map((card, index) => (

                <div
                    key={index}
                    className="food-stat-card"
                >

                    <div className={`food-stat-icon ${card.color}`}>

                        {card.icon}

                    </div>

                    <div className="food-stat-content">

                        <h3>{card.value}</h3>

                        <p>{card.title}</p>

                    </div>

                </div>

            ))}

        </div>

    );

}

export default FoodStats;